import React from 'react';
import { lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const BorderLinearProgress = withStyles({
  root: {
    height: 10,
    borderRadius: 20,
    marginTop: '-7px',
    backgroundColor: '#ffffff',
  },
  bar: {
    borderRadius: 20,
    backgroundColor: '#C377E0',
  },


})(LinearProgress);

export default function LinearIndeterminate(props) {
  
  const [progress, setProgress] = React.useState(0) 


    React.useEffect(() => {
      let value = parseInt(props.MonthVunneProspekt.monthV)/(parseInt(props.MonthVunneProspekt.monthB)===0?10000:props.MonthVunneProspekt.monthB)*100
      setProgress(value > 100 ? 100 : value)

    })


  return (

    <div>
      <BorderLinearProgress
        variant="determinate"
        value={progress}
      />
    </div>
  
  );
}